import MyFirmApplicationsPage from "./pages/MyFirmApplicationsPage";
import FirmApplicationWizard from "./pages/FirmApplicationWizard";
import FirmApplicationDetailsPage from "./pages/FirmApplicationDetailsPage";
import FirmPaymentProcessingPage from "./pages/FirmPaymentProcessingPage";
import MyFirmPartnerRequestsPage from "./pages/MyFirmPartnerRequestsPage";
import MyFirmRefereeRequestsPage from "./pages/MyFirmRefereeRequestsPage";
import AdminFirmApplicationsPage from "./pages/AdminFirmApplicationsPage";
import FirmRegistryPage from "./pages/FirmRegistryPage";
import MyFirmPage from "./pages/MyFirmPage";
import MyFirmInvoicesPage from "./pages/MyFirmInvoicesPage";
import AdminFirmApplicationDetailPage from "./pages/AdminFirmApplicationDetailPage";
import ChapterFirmApplicationsPage from "./pages/ChapterFirmApplicationsPage";
import ChapterFirmApplicationDetailPage from "./pages/ChapterFirmApplicationDetailPage";
import MyFirmReviewsPage from "./pages/MyFirmReviewsPage";

const CHAPTER_ROLES = ["chapter_chairman", "chapter_secretary"];

// The Membership Committee's Spatie roles (Committee::roleSlug()) — the same
// pair the upgrade and entry review screens gate on.
const COMMITTEE_ROLES = ["committee_membership_committee", "committee_membership_committee.chairman"];

const MEMBER_ROLES = [
  "member", "fellow", "executive", "chairman", "secretary",
  "assessor", "past president", "probationer", "student", "technician",
];

export const firmApplicationRoutes = [
  { path: "/firm-applications", element: <MyFirmApplicationsPage />, roles: MEMBER_ROLES },
  { path: "/firm-applications/new", element: <FirmApplicationWizard />, roles: MEMBER_ROLES },
  { path: "/firm/payment-processing/:id", element: <FirmPaymentProcessingPage />, roles: MEMBER_ROLES },
  { path: "/firm-partner-requests", element: <MyFirmPartnerRequestsPage />, roles: MEMBER_ROLES },
  { path: "/firm-referee-requests", element: <MyFirmRefereeRequestsPage />, roles: MEMBER_ROLES },
  { path: "/firm-applications/:id", element: <FirmApplicationDetailsPage />, roles: MEMBER_ROLES },

  // A firm as its OWNER sees it — their firm's details, roster and dues, and
  // the way to pay them. "firm" is in the roles because an imported firm signs
  // in on its own account, which carries that whois.
  { path: "/my-firm", element: <MyFirmPage />, roles: [...MEMBER_ROLES, "firm"] },

  // The money on its own. Declared after /my-firm, and a distinct path rather
  // than a child of it, because the firm's menu reaches the two separately: the
  // register entry, and what it owes.
  {
    path: "/my-firm/invoices",
    element: <MyFirmInvoicesPage />,
    roles: [...MEMBER_ROLES, "firm"],
  },

  // Admin (permission-gated)
  // The register of firms stands on its own, beside the applications queue
  // rather than inside it: one is who IS registered, the other is what is
  // waiting on the secretariat.
  // Gated on the PRIVILEGE alone, not on also holding the `admin` role — the
  // accounting offices work the register and an accountant is not an admin.
  // What each of them may DO on the page is gated per action; see PERMS.firm.
  { path: "/firm-registry", element: <FirmRegistryPage />, perms: ["firms.access"] },
  { path: "/admin/firm-applications", element: <AdminFirmApplicationsPage />, perms: ["firm_applications.access"] },
  { path: "/admin/firm-applications/:id", element: <AdminFirmApplicationDetailPage />, perms: ["firm_applications.access"] },

  // Chapter endorsement
  { path: "/chapter/firm-applications", element: <ChapterFirmApplicationsPage />, roles: CHAPTER_ROLES },
  { path: "/chapter/firm-applications/:id", element: <ChapterFirmApplicationDetailPage />, roles: CHAPTER_ROLES },

  // Membership Committee — the assigned member's decision screen.
  { path: "/committee/firm-reviews", element: <MyFirmReviewsPage />, roles: COMMITTEE_ROLES },
];
